import { useMemo, useState } from 'react';
import {
  ActionData,
  actionsHandlerService,
  ActionStatus,
  ActionType
} from './action-handler.service';

export function useActionsHandler<T>(actionId: string, type: ActionType, metaData?: unknown) {
  const initialStatus = {
    status: ActionStatus.INIT,
    type,
    metaData,
    progress: 0,
    error: null,
    result: null
  };

  const [status, setStatus] = useState<ActionData<T>>(initialStatus);

  useMemo(() => {
    return actionsHandlerService.getActionStatus<T>(actionId).subscribe(s => {
      setStatus(s || initialStatus);
    });
  }, []);

  const performAction = (dataSource$: Promise<T>) => {
    actionsHandlerService.performAction(actionId, type, metaData, dataSource$);
  };

  const abortAction = () => {
    actionsHandlerService.cancelAction(actionId);
  };

  return {
    status,
    performAction,
    abortAction
  };
}
